import { render, staticRenderFns } from "./CommentEmote.vue?vue&type=template&id=424d6718&scoped=true"
import script from "./CommentEmote.vue?vue&type=script&lang=ts"
export * from "./CommentEmote.vue?vue&type=script&lang=ts"
import style0 from "./CommentEmote.vue?vue&type=style&index=0&id=424d6718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424d6718",
  null
  
)

export default component.exports